module.exports = __webpack_public_path__ + "ipetbooking/admin/img/staff_avatar_haku.d71bfdb4.png";